import { Flex, Spinner } from "@chakra-ui/react";
import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../lib/accountContext";
import { useRedirectToLogin } from "../../lib/hooks";
import Nav from "../NavBar";
import toast, { Toaster } from 'react-hot-toast';

export default function BillingPortalRedirect() {
  const navigate = useNavigate();

  const openBillingPortal = async () => {
    const res = await axios.post("/create-billing-portal").catch((e) => {
      console.error(e);
      toast.error("Sorry, we had an issue opening the billing portal. Feel free to email us at cfahlgren1@gmail.com")
      navigate("/");
    });
    if (res.data) {
      // Replace URL in case the user presses the back button after redirect
      window.history.replaceState(null, "", "/");
      window.location.href = res.data.url;
    }
  };

  const user = useUser();
  useRedirectToLogin();

  useEffect(() => {
    if (user) openBillingPortal();
  }, [user]);

  return (
    <Flex direction={"column"} minH={"100vh"}>
      <Nav />
      <Spinner mx="auto" my={36} size={"xl"} />
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
    </Flex>
  );
}
